"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomId = exports.getCustomerName = void 0;
const homi_shared_1 = require("@getgreenline/homi-shared");
const BLAZE_COMPANY = 'BLAZE';
const getCustomerName = (payment) => {
    var _a, _b;
    if (payment instanceof homi_shared_1.CreatePayment) {
        return ((_a = payment.customerWithHistory) === null || _a === void 0 ? void 0 : _a.customer.name) || ((_b = payment.customer) === null || _b === void 0 ? void 0 : _b.name);
    }
    return payment.customerName || undefined;
};
exports.getCustomerName = getCustomerName;
const getCustomId = (payment) => {
    const sourceName = 'externalSourceName' in payment && payment.externalSourceName
        ? payment.externalSourceName
        : BLAZE_COMPANY;
    const orderId = 'externalOrderId' in payment && payment.externalOrderId
        ? payment.externalOrderId
        : 'No order ID';
    return `${sourceName} - ${orderId}`;
};
exports.getCustomId = getCustomId;
//# sourceMappingURL=packingSlipHelpers.js.map